<script lang="ts">
  import { currentPanel, hasDefault, hasPanel, sidePanel } from "$stores/sidePanel";
  import SidePanelLayout from "./SidePanelLayout.svelte";
  import type { ComponentType, SvelteComponent } from "svelte";

  $: show = ($hasDefault || $hasPanel) && $sidePanel.visible;

  // What follows is a workaround for a very bizarre bug, probably a bug in Svelte rather than
  // due to our code. For some reason, when changing panels, the old svelte:component instance
  // attached to the old panel was sometimes not being destroyed. The workaround is simply to
  // manually call $destroy() on the old instance when the panel changes.
  let oldInstanceRef: SvelteComponent | null = null;
  let newInstanceRef: SvelteComponent | null = null;
  let panel: ComponentType | null = null;
  let data = {};
  $: {
    if ($currentPanel.panel !== panel) {
      if (oldInstanceRef) {
        oldInstanceRef.$destroy();
      }
    }
    oldInstanceRef = newInstanceRef;

    data = $currentPanel.data;
    panel = $currentPanel.panel;
  }
</script>

<SidePanelLayout {show} slideTo="left" withOverlay withBorder>
  <svelte:component this={panel} bind:this={newInstanceRef} {...data} />
</SidePanelLayout>
